export default "__VITE_ASSET__CPhX51OR__"